import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/Spinner.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstroEmail.propTypes = {};

function DashboardAstroEmail(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  

  const { logout } = useContext(AuthContext);

  
const [astrologerId, setAstrologerId] = useState(null);

    useEffect(() => {
      const storedUserId = localStorage.getItem("astrologerId");
      if (storedUserId) {
        setAstrologerId(storedUserId);
      }
    }, []);
    
const [astrologerStatusnew, setAstrologerStatusnew] = useState({ Named: "", Id: "" });
  useEffect(() => {
    const fetchAstrologerStatusnew = async () => {
  
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getastrologerbyidprofile/${astrologerId}`);
        if (response.data) {
          setAstrologerStatusnew({
            Named: response.data.Named,
            Id: response.data.Id,
            Email: response.data.Email,
          });
        }
      } catch (error) {
        console.error("Error fetching astrologer status:", error);
      }
    };
  
    fetchAstrologerStatusnew();
  }, [astrologerId]);

  const [isSending, setIsSending] = useState(false);
 const sendVerificationEmail = async () => {
  setIsSending(true); // Disable button

  try {
    const response = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/send-verification",
      {
        astrologerId,
        email: astrologerStatusnew.Email,
      }
    );

    toast.success(response.data.message);

    
   setTimeout(() => {
     window.location.href = "/completeprofile";
   }, 5000);
  } catch (error) {
    console.error("Error sending verification email:", error);
    toast.error("Failed to send verification email.");
  } finally {
    setIsSending(false); // Re-enable in all cases
  }
};

  return (
    <>
    <Helmet>
            <title>Verify Your Email Address - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
        <Breadcrumbastrologer title="Verify Your Email Address" />
       
        <section className="account-section" style={{backgroundColor:"#fafafa"}}>
              <div className="tf-container">
                <div className="row">
                  <div className="wd-form-login">
                  <img src={require ('../../assets/siteimages/emailicon.png')} style={{width:"120px", height:"auto", margin:"auto", padding:"auto", paddingTop:"25px", paddingBottom:"15px"}} alt="images" />
                  <h5 style={{fontSize:"27px"}}>Verify Your Email Address</h5>
                  <p style={{marginBottom:"20px"}}>We will send a verification link to verify your email address.<br/><br/>Click on the link to complete the verification process.<br/>You might need to <span style={{fontWeight:"bold"}}>check your spam folder</span></p>
                   
                      <div className="ip">
                        
                        <input
          type="email"
          value={astrologerStatusnew.Email}
          disabled
        />
                      </div>
                    <button onClick={sendVerificationEmail} disabled={isSending}>
  {isSending ? "Please Wait..." : "Send Verification Email"}
</button>
 <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
                        <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                                           
                                                                            <Link to="/completeprofile" className="forgot" style={{margin:"auto"}}>
                                                                                                                                                           Return To Verification Desk
                                                                                                                                                         </Link>
                                                                          </div>
                   
                  </div>
                </div>
              </div>
            </section>
       
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
     
      <Gotop />
    </>
  );
}

export default DashboardAstroEmail;
